export const handleResize = (
  delta,
  setImages,
  activeImage,
  stageRef,
  selectedFaces,
  selectedBodies
) => {
  if (activeImage && stageRef.current) {
    const stage = stageRef.current;
    const canvasHeight = stage.height();
    const canvasWidth = stage.width();
    setImages((prevImages) => {
      return prevImages.map((image) => {
        if (image.src === activeImage) {
          const newWidth = Math.max(image.width + delta, 5);
          const newHeight = Math.max(newWidth / image.aspectRatio, 5);

          const isFace = selectedFaces.includes(image.originalSrc);
          const isBody = selectedBodies.includes(image.originalSrc);

          if (isFace) {
            const maxFaceSize = canvasHeight * 0.8;
            const minFaceSize = canvasHeight * 0.1;

            // Prevent resizing beyond canvas right/bottom edges for current position
            const availableHeight = Math.max(0, canvasHeight - image.position.y);
            const availableWidth = Math.max(0, canvasWidth - image.position.x);
            const maxHeightByWidth = availableWidth / image.aspectRatio;
            const maxAllowedHeight = Math.min(maxFaceSize, availableHeight, maxHeightByWidth);

            const growOK = delta > 0 && newHeight <= maxAllowedHeight;
            const shrinkOK = delta < 0 && newHeight >= minFaceSize;
            if (growOK || shrinkOK) {
              const clampedHeight = Math.max(Math.min(newHeight, maxAllowedHeight), minFaceSize);
              const clampedWidth = clampedHeight * image.aspectRatio;
              return { ...image, width: clampedWidth, height: clampedHeight };
            }
            return image;
          }

          if (isBody) {
            const maxBodySize = canvasHeight;
            const minBodySize = canvasHeight * 0.7;
            if (newHeight <= maxBodySize && newHeight >= minBodySize) {
              return { ...image, width: newWidth, height: newHeight };
            }
          }
        }
        return image;
      });
    });
  }
};

export const handleFlip = async (
  setActiveImage,
  activeImage,
  images,
  setImages
) => {
  if (activeImage) {
    const imageToFlip = images.find((image) => image.src === activeImage);

    if (imageToFlip) {
      const img = new Image();
      img.src = imageToFlip.src;
      img.crossOrigin = "anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        const currentPosition = { ...imageToFlip.position };

        ctx.translate(img.width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(img, 0, 0);

        const flippedDataUrl = canvas.toDataURL();

        setImages((prevImages) =>
          prevImages.map((image) => {
            if (image.src === activeImage) {
              return {
                ...image,
                src: flippedDataUrl,
                flipped: !image.flipped,
                position: currentPosition,
              };
            }
            return image;
          })
        );

        setActiveImage(flippedDataUrl);
      };

      img.onerror = (error) => {
        console.error("Error loading image for flip:", error);
      };
    }
  }
};

export const handleUpdatePosition = (
  src,
  newPosition,
  hasMoved = false,
  setImages
) => {
  setImages((prevImages) =>
    prevImages.map((image) => {
      if (image.src === src) {
        return { ...image, position: newPosition, hasMoved };
      }
      return image;
    })
  );
};

export const handleZIndexChange = (direction, activeImage, stageRef) => {
  if (activeImage && stageRef.current) {
    const layer = stageRef.current.children[0];
    const konvaImage = layer.findOne(
      (node) => node.attrs.image.src === activeImage
    );

    if (konvaImage) {
      if (direction === "up") {
        konvaImage.moveUp();
      } else if (direction === "down") {
        konvaImage.moveDown();
      }
      layer.draw();
    }
  }
};
